/**
 * 작성자 : 홍선영
 * 날짜 : 2024.10.15
 * 기능 : 대시보드 위젯 데이터가 로딩 중일 때 표시되는 스켈레톤 UI를 구현한 컴포넌트
 */

import { useMemo } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'; // Skeleton 라이브러리 추가
import 'react-loading-skeleton/dist/skeleton.css'; // 스켈레톤 스타일 적용
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { bScreenMode } from '../atoms';
import { dark, light } from '../assets/styles/theme';

// Skeleton 스타일 컴포넌트
const SkeletonTableStyle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem;

  .skeleton-row {
    margin-bottom: 0.5rem;
    > div {
      width: 100%;
    }
  }
`;

const SkeletonTable = ({ rows = 6, mainRowWidth = '95%', mainRowHeight = 30, rowHeight = 30 }) => {
  const colorMode = useRecoilValue(bScreenMode); // 현재 테마 상태

  // 스켈레톤의 너비를 설정하는 useMemo 훅
  const widths = useMemo(
    () => [
      `${Math.floor(Math.random() * 40 + 60)}%`, // 첫 번째 행의 랜덤 너비 설정
      ...Array(rows)
        .fill(null)
        .map(() => `${Math.floor(Math.random() * 40 + 60)}%`), // 나머지 행에 랜덤 너비 설정
    ],
    [rows] // rows가 변경될 때만 다시 계산
  );

  const getRandomWidth = () => `${Math.floor(Math.random() * 40 + 60)}%`;
  const fixedWidth = [
    { id: 0, width: 80 },
    { id: 1, width: 40 },
    { id: 2, width: 60 },
    { id: 3, width: 84 },
    { id: 4, width: 49 },
    { id: 5, width: 73 },
    { id: 6, width: 84 },
    { id: 7, width: 91 },
    { id: 8, width: 61 },
  ];

  return (
    <SkeletonTableStyle>
      <SkeletonTheme baseColor='var(--skeleton-base)' highlightColor='var(--skeleton-highlight)'>
        <div className='skeleton-row'>
          <Skeleton height={mainRowHeight} width={mainRowWidth} />
        </div>
        {rows > 0 &&
          [...Array(rows)].map((_, index) => (
            <div key={index} className='skeleton-row'>
              <Skeleton height={rowHeight} width={`${fixedWidth[index]?.width ?? 60}%`} />
            </div>
          ))}
      </SkeletonTheme>
    </SkeletonTableStyle>
  );
};

export default SkeletonTable;
